import React from 'react';
import { bool, func } from 'prop-types';
import styled, { css } from 'styled-components';
import {
  Button, Flex, Typography, Icon, Modal,
} from '@atoms';
import { ReactComponent as Close } from '@assets/remove-item.svg';

const EditWarning = ({
  onWarningClose,
  isWarningOpen,
}) => (
  <Modal
    isOpen={isWarningOpen}
    ariaHideApp={false}
    onRequestClose={onWarningClose}
    shouldCloseOnOverlayClick
  >
    <ButtonClose primary onClick={onWarningClose}>
      <Flex justifyCenter itemsCenter>
        <Icon SVG={Close} width="20px" height="20px" />
      </Flex>
    </ButtonClose>
    <Typography size="xl" weight="black">
      Please save your changes before going to the next page!
    </Typography>
  </Modal>
);

const ButtonClose = styled(Button.Circular)`
  ${({ theme: { spacing } }) => css`
    padding: ${spacing.xs};
    position: absolute;
    top: 10px;
    right: 10px;
  `}
`;

EditWarning.propTypes = {
  onWarningClose: func.isRequired,
  isWarningOpen: bool.isRequired,
};

export default EditWarning;
